export default __webpack_public_path__ + "static/media/add.05c1dd49.svg";